import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import Countdown from '../../components/Countdown';

// Rounds
@inject('Game2Store')
@observer
export default class GameStep4 extends Component {

    static defaultProps = {
        onChangeAnswer: () => {}
    };

    constructor(props) {
        props.Game2Store.setPlayersTurn();
        super(props);

        this.selected0 = false;
        this.selected1 = false;
    }

    componentDidUpdate() {
        const btns = document.querySelectorAll(".btn-answer");
        for (let bt of btns) {
            bt.className = "btn-answer";
        }

        const btnNavNext = document.querySelector(".btn-nav-next");
        btnNavNext.className = "btn-nav-next disabled";
    }

    addPointsToScore(player, index, e) {
        this.props.onChangeAnswer({player, index});

        const btns = document.querySelectorAll(".btn-answer");
        for (let bt of btns) {
            if (bt.name === "btn" + index) {
                if( bt.className == "btn-answer selected" ) {
                    bt.className = "btn-answer";
                    this.selected = false;
                    this.props.Game2Store.pause = false;
                    this.props.Game2Store.start = true;
                } else {
                    bt.className = "btn-answer selected";
                    this.selected = true;
                    this.props.Game2Store.pause = true;
                    this.props.Game2Store.start = false;
                }

                const btnNavNext = document.querySelector(".btn-nav-next");
                if( !this.selected ) {
                    btnNavNext.className = "btn-nav-next disabled";
                } else {
                    btnNavNext.className = "btn-nav-next";
                }
            } else {
                bt.className = "btn-answer";
            }
        }
    }

    render() {

        const {
            Game2Store
        } = this.props;

        const player = Game2Store.getPlayerTurn();
        const question = Game2Store.getRandomQuestionByLevel(player.levels);

        const answersEl = Game2Store.answers.map(
            (answer, index) => <button
                name={"btn" + index}
                className="btn-answer"
                key={index}
                onClick={this.addPointsToScore.bind(this, player, index)}>{answer.label}</button>
        );

        return (
            <div className="step-4">
                <ScoreBar players={Game2Store.players}/>
                <h1>Round {Math.ceil(Game2Store.round / Game2Store.numberPlayers)}</h1>
                <div className={"team-name " + player.team.color}>{player.name}</div>
                <Countdown/>
                <div>
                    <div className="question">
                        {question.statement.image &&
                            <div className="question-image"
                                style={{backgroundImage: `url(images/${question.statement.image}.jpg)`}}/>
                        }
                        <div className="question-statement">
                            <p><strong>{question.level}</strong> <br/>{question.statement.statement}</p>
                            <div className="answers">
                                {answersEl}
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        )
    }
}

const ScoreBar = ({players = []}) => {

    const scores = players.map(
        (player, index) => (
            <Score key={index} player={player} />
        )
    );

    return (
        <div className="ScoreBar">
            {scores}
        </div>
    )
};

const Score = ({player}) => {
    return (
        <div className="Score">
            <div className={"team-name " + player.team.color}>{player.name}</div>
            <div>{player.score} Points</div>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/containers/Game2/Game2Step4.js